import React from 'react';
import { choose } from '../../utils/platform';
import { useGuestHome } from './useGuestHome';
import GuestHomeDesktop from './GuestHome.desktop';
import GuestHomeMobile from './GuestHome.mobile';

const GuestHomeView = choose(GuestHomeDesktop, GuestHomeMobile);

// /guest — the signed-in guest's screen (see utils/guestSession).
export default function GuestHome() {
  const vm = useGuestHome();
  if (!vm.ready) return null; // no guest session: the hook sends them to sign-in
  return <GuestHomeView vm={vm} />;
}
